import { Truck } from "lucide-react";

// The one quiet line an item's Details keeps about delivery (Ben, 5 Oct):
// the Delivery tab owns where things go, so this only says how many places
// and links there. The same on the quote and the order page.

export function DeliveryLink({
  addressNames,
  onOpen,
}: {
  addressNames: string[];
  onOpen: () => void;
}) {
  const unique = [...new Set(addressNames)];
  if (unique.length === 0) return null;
  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
    >
      <Truck className="size-4 shrink-0" />
      Delivery: {unique.length === 1
        ? unique[0]
        : `${unique.length} addresses`}{" "}
      ›
    </button>
  );
}
